"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/ReplyQuoteBlock.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _conversation = require('shared/selectors/conversation');
var _replyPreview = require('shared/services/replyPreview');
var _ReplyPreviewStrip = require('../ReplyPreviewStrip'); var _ReplyPreviewStrip2 = _interopRequireDefault(_ReplyPreviewStrip);
var _hooks = require('web/services/hooks');








const ReplyQuoteBlock = ({
  conversationKey,
  replyToMessageKey,
  replyPreview,
  onJumpToMessage,
}) => {
  const targetFacts = _hooks.useAppSelector.call(void 0, state =>
    _conversation.selectReplyTargetFacts.call(void 0, state, conversationKey, replyToMessageKey),
  )
  const resolved = _replyPreview.resolveReplyPreview.call(void 0, replyPreview, targetFacts)
  const handleClick = _react.useCallback.call(void 0, 
    () => onJumpToMessage(replyToMessageKey),
    [onJumpToMessage, replyToMessageKey],
  )

  if (!resolved) return null

  return (
    _react2.default.createElement('button', {
      type: "button",
      className: "reply-quote",
      'aria-label': `Jump to message from ${resolved.displayName}`,
      onClick: handleClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}

      , _react2.default.createElement(_ReplyPreviewStrip2.default, { preview: resolved, variant: "quote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}} )
    )
  )
}

exports. default = ReplyQuoteBlock
